import { Injectable, Injector } from "@angular/core";
import {
    FIELD_TYPE,
    FieldSchema,
    MCFieldStylesService,
    MCFieldExpressionsService,
    MCFieldSectionsService,
    SectionSchema,
    FormisForm,
    MCFieldTranslateService,
    MCFieldTooltipService,
    MCFieldsCustomValidator
} from "@maslul/common-services";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { FieldsPropsService } from "./props";
import { TranslateService } from "@ngx-translate/core";
import { MICustomFunctionsParams } from "../../models/fields/custom-function-params";
import { HooksService } from "./hooks.service";
import { FieldsValidationService } from "./validation";


@Injectable({
    providedIn: 'root'
})
export class FieldsMapperService {
    fieldType = FIELD_TYPE;

    constructor(
        private sectionsService: MCFieldSectionsService
        , private hooksService: HooksService
        , private fieldsPropsService: FieldsPropsService
        , private translateService: TranslateService
        , private fieldsServiceExpressions: MCFieldExpressionsService
        , private fieldStylesService: MCFieldStylesService
        , private injector: Injector
        , private fieldTranslateService: MCFieldTranslateService
        , private fieldTooltipService: MCFieldTooltipService
        , private fieldsValidationService: FieldsValidationService
    ) { }

    generateSchema(
        sectionsSchema: Array<SectionSchema>,
        formisForm: FormisForm
    ): Array<FormlyFieldConfig> {
        const sectionsfields = new Array<FormlyFieldConfig>();

        sectionsSchema.forEach((sectionSchema: SectionSchema) => {

            const generatedfields = new Array<FormlyFieldConfig>();

            sectionSchema.fieldsSchema.forEach((fieldSchema: FieldSchema) => {

                if (fieldSchema.type == FIELD_TYPE.REPEAT) {

                    const repeatConfiguration: FormlyFieldConfig = this.initRepeatFields(
                        fieldSchema,
                        formisForm,
                        sectionsSchema,
                        sectionSchema
                    );
                    //                    generatedfields.find(f => f.key == field.name).fieldArray['resetOnHide'] = false;
                    generatedfields.push(repeatConfiguration);

                }
                else {
                    const customFunctionsParams: MICustomFunctionsParams =
                        this.initCustomFunctionParams(
                            fieldSchema,
                            formisForm,
                            sectionsSchema,
                            sectionSchema,
                            false
                        );
                    const generatedfield: FormlyFieldConfig = this.initFieldConfiguration(customFunctionsParams);
                    generatedfields.push(generatedfield);
                }
            });

            const schemaConfiguration = this.initSectionConfiguration(sectionSchema, generatedfields);
            sectionsfields.push(schemaConfiguration);
        });
        return sectionsfields;
    }

    initSectionConfiguration(
        schema: SectionSchema,
        geneartedfields: Array<FormlyFieldConfig>
    ): FormlyFieldConfig {

        const section = {
            key: schema.section,
            wrappers: this.sectionsService.getSectionWrappers(schema),
            props: this.fieldsPropsService.getSectionProps(schema),
            expressionProperties: {
                'props.label': schema.section ? this.translateService.stream('labels.' + schema.section) : schema.section,

            },
            hideExpression: this.fieldsServiceExpressions.hideSection,
            resetOnHide: false,
            fieldGroupClassName: "row",
            fieldGroup: geneartedfields
        }

        return section;
    }

    initFieldConfiguration(
        customFunctionsParams: MICustomFunctionsParams
    ): FormlyFieldConfig {
        const fieldSchema = customFunctionsParams.fieldSchema;

        return {
            id: fieldSchema.name,
            key: fieldSchema.name,
            type: FIELD_TYPE[fieldSchema.type].toLowerCase(),
            className: this.fieldStylesService.getClass(fieldSchema),
            hooks: {
                onInit: this.hooksService.hooksInit(customFunctionsParams)
            },
            defaultValue: this.fieldTranslateService.getDefaultValue(fieldSchema, fieldSchema.defaultValue, 'labels.'),
            props: this.fieldsPropsService.getFieldConfigurationProps(customFunctionsParams),
            expressionProperties: {
                'props.label': this.fieldTranslateService.getLabel(fieldSchema, fieldSchema.label, 'labels.'),
                'props.required': this.fieldsServiceExpressions.requiredExpression,
                'props.disabled': this.fieldsServiceExpressions.disabledExpression,
                'props.tooltip': this.fieldTooltipService.getFieldTooltip,

            },
            hideExpression: this.fieldsServiceExpressions.hideExpression,
            resetOnHide: false,

            fieldGroupClassName: "row",
            validation: {
                custom: this.fieldsValidationService.getAllCustomValidationField(fieldSchema),
                injector: customFunctionsParams.injector,
                model: customFunctionsParams.formisForm.model
            },
            validators: {
                validation: [MCFieldsCustomValidator.customValidator]
            },
            asyncValidators: {
                // validation: [CustomValidator.customAsyncValidator]
            }
        };


    }

    initRepeatFields(
        fieldSchema: FieldSchema,
        formisForm: FormisForm,
        sectionsSchema: Array<SectionSchema>,
        sectionSchema: SectionSchema
    ) {



        const repeatConfiguration: FormlyFieldConfig = this.initRepeatConfiguration(fieldSchema);

        fieldSchema.fields.forEach((repeatFieldSchema: FieldSchema) => {
            const customFunctionsParams: MICustomFunctionsParams =
                this.initCustomFunctionParams(
                    repeatFieldSchema,
                    formisForm,
                    sectionsSchema,
                    sectionSchema,
                    true
                );
            const generatedfield: FormlyFieldConfig = this.initFieldConfiguration(customFunctionsParams);

            let fieldConfig = repeatConfiguration.fieldArray;

            if (typeof fieldConfig === 'function') {//חייב בגלל הTS
                fieldConfig = fieldConfig(repeatConfiguration);
            }

            if (fieldConfig?.fieldGroup) {
                fieldConfig.fieldGroup.push(generatedfield)

            }
        })

        return repeatConfiguration;
    }

    initRepeatConfiguration(
        field: FieldSchema
    ): FormlyFieldConfig {


        return {
            id: field.name,
            key: field.name,
            type: FIELD_TYPE[field.type].toLowerCase(),
            className: "col-md-12",
            defaultValue: [{}],
            props: this.fieldsPropsService.getRepeatProps(field),
            expressionProperties: {
                'props.label': this.fieldTranslateService.getLabel(field, field.label ?? field.name, 'labels.'),
                //'props.disabled': customFunctionsParams.fieldSchema.disableCondition ? this.fieldsServiceExpressions.disabledExpression : null,
            },
            hideExpression: this.fieldsServiceExpressions.hideExpression,
            resetOnHide: false,
            fieldArray: {
                fieldGroup: new Array<FormlyFieldConfig>()
            },
            fieldGroupClassName: 'row'
        }
    }


    initCustomFunctionParams(
        fieldSchema: FieldSchema,
        formisForm: FormisForm,
        sectionsSchema: Array<SectionSchema>,
        sectionSchema: SectionSchema,
        isInRepeat: boolean
    ): MICustomFunctionsParams {

        const customFunctionsObj = new MICustomFunctionsParams();

        customFunctionsObj.fieldSchema = fieldSchema;
        customFunctionsObj.formisForm = formisForm;
        customFunctionsObj.sectionsSchema = sectionsSchema;
        customFunctionsObj.injector = this.injector;
        customFunctionsObj.isInRepeat = isInRepeat;
        customFunctionsObj.sectionSchema = sectionSchema;

        return customFunctionsObj;
    }


}